import { snakeCase } from 'lodash';

export function hasAllDealTypes(customField, options) {
  return customField.dealTypes.length === options.dealTypes.length ||
    (customField.dealTypes.length === 1 && customField.dealTypes[0] === 'all');
}

export function getCategoryLabel(customField, options) {
  return options.categories.find(option => option.value === customField.category)?.label || 'Custom fields';
}

export function getDealTypeLabel(customField, options) {
  if (hasAllDealTypes(customField, options)) {
    return 'All';
  } else {
    return options.dealTypes
      .filter(option => customField.dealTypes.includes(option.value))
      .map(option => option.label)
      .join(', ');
  }
}

export function getTypeLabel(customField, options) {
  return options.types.find(option => option.value === customField.type)?.label;
}

export function swapSortOrders(customFields, name1, name2) {
  const reordered = customFields.map(customField => ({ ...customField }));

  let customField1, customField2;
  for (const customField of reordered) {
    if (customField.name === name1) {
      customField1 = customField;
    } else if (customField.name === name2) {
      customField2 = customField;
    }

    if (customField1 && customField2) {
      const sortOrder1 = customField1.sortOrder;
      customField1.sortOrder = customField2.sortOrder;
      customField2.sortOrder = sortOrder1;
      break;
    }
  }

  return reordered.sort((customField1, customField2) => customField1.sortOrder - customField2.sortOrder);
}

export function serialize(customField, customFields, options, { isNew = false } = {}) {
  const serializedField = { ...customField };

  delete serializedField.classFlags;

  if (hasAllDealTypes(serializedField, options)) {
    serializedField.dealTypes = ['all'];
  }

  serializedField.options = serializedField.options?.filter(option => option);
  if (!serializedField.options?.length || serializedField.type !== 'text') {
    delete serializedField.options;
  }

  if (isNew) {
    setUniqueName(serializedField, customFields);
  }

  if (serializedField.marketing?.useNameForField) {
    serializedField.marketing.field = serializedField.name;
    delete serializedField.marketing.useNameForField;
  }

  return serializedField;
}

function setUniqueName(customField, customFields) {
  customField.name = `c_${snakeCase(customField.label)}`;

  while (customFields.some(existingCustomField => customField.name === existingCustomField.name)) {
    const suffix = /_v\d+$/.exec(customField.name);
    if (suffix) {
      const nextSuffix = `_v${parseInt(suffix[0].replace(/^_v/, '')) + 1}`;
      customField.name = customField.name.replace(new RegExp(`${suffix}$`), nextSuffix);
    } else {
      customField.name += '_v2';
    }
  }
}

export const classFlagOptions = [
  { label: 'Deal', name: 'deal' },
  { label: 'Comp', name: 'comp' },
  { label: 'Property', name: 'property' },
];

export function getClassFlags(field) {
  return {
    comp: field.classNames.includes('Research::Sale') || field.classNames.includes('Research::Lease'),
    deal: field.classNames.includes('Apex::Deal'),
    property: field.classNames.includes('Research::Property'),
  };
}

export function getClassFlagLabels(field) {
  const classFlags = getClassFlags(field);
  return classFlagOptions
    .filter(option => classFlags[option.name])
    .map(option => option.label);
}
